<template>

	<div class="video-card">
		<div class="video-card-video">
			<iframe width="260" height="150" :src="'https://www.youtube.com/embed/'+videoId+additionalUrlParams" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
		</div>
		<h4>{{ title }}</h4>
		<p>{{ description }}</p>
	</div>

</template>

<script>
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		let svgStore = useSvgStore();
		return {getIcon: svgStore.get};
	},
	name: "FunnelVideoCard",
	data() {
		return {

		}
	},
	props: {
		videoId: {
			type: String,
			required: true
		},
		title: {
			type: String,
			default: ''
		},
		description: {
			type: String,
			default: ''
		},
		start: {
			type: Number,
			default: 0
		},
		end: {
			type: Number,
			default: 0
		}
	},
	computed: {
		additionalUrlParams() {
			let finalParams = '';
			if(this.start) {
				finalParams += finalParams ? '&amp;' : '?';
				finalParams += 'start='+this.start;
			}
			if(this.end && (!this.start || this.end > this.start)) {
				finalParams += finalParams ? '&amp;' : '?';
				finalParams += 'end='+this.end;
			}
			return finalParams;
		}
	}
}
</script>

<style lang="scss" scoped>
.video-card {
	background-color: var(--color-alpha-1);
	width: 300px;
	border-radius: 16px;
	padding: 20px;

	.video-card-video {
		@include centered;
		width: 100%;
		margin-bottom: 10px;

		iframe{
			margin: 0 auto;
			border-radius: 12px;
		}
	}

	h4 {
		color: var(--color-primary);
		margin-bottom: 4px;
	}

	@media (max-width: 320px) {
		width: 100%;
	}
}
</style>